/* ================================================================
   Magnetic Track Configurator — Vanilla JS state machine
   ================================================================
   3-step guided flow:
     1. Customer type
     2. Track type
     3. Brief + Name + WhatsApp → Submit redirects to wa.me
   Fires Microsoft Clarity Smart Events at every step.
   No external dependencies. Works on every Shopify theme.
   ================================================================ */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-mt-configurator]');
  if (!roots.length) return;

  roots.forEach(initConfigurator);

  function initConfigurator(root) {
    var whatsappBase = root.getAttribute('data-mt-whatsapp') || 'https://wa.me/919899188821';
    var state = {
      customer_type: '',
      track_type: '',
      brief: '',
      name: '',
      phone: '',
      currentStep: 1
    };

    var steps = root.querySelectorAll('[data-mt-step]');
    var progressBar = root.querySelector('[data-mt-progress]');
    var stepLabel = root.querySelector('[data-mt-step-label]');

    // Fire Clarity event helper
    function fireClarity(name, data) {
      try {
        if (window.clarity) {
          window.clarity('event', name);
          if (data) {
            Object.keys(data).forEach(function (k) {
              window.clarity('set', k, String(data[k]));
            });
          }
        }
      } catch (e) { /* Clarity not loaded */ }
    }

    // Show a specific step
    function showStep(stepKey) {
      steps.forEach(function (el) {
        if (el.getAttribute('data-mt-step') === String(stepKey)) {
          el.removeAttribute('hidden');
          el.setAttribute('data-mt-step-active', 'true');
          // fire step-entry event if defined
          var ev = el.getAttribute('data-mt-event-step');
          if (ev) fireClarity(ev);
        } else {
          el.setAttribute('hidden', '');
          el.removeAttribute('data-mt-step-active');
        }
      });

      // update progress
      var stepNum = (stepKey === 'thanks') ? 3 : parseInt(stepKey, 10);
      if (!isNaN(stepNum)) {
        state.currentStep = stepNum;
        if (progressBar) progressBar.style.width = (stepNum / 3 * 100) + '%';
        if (stepLabel) stepLabel.textContent = 'Step ' + stepNum + ' of 3';
      }
    }

    // Click handler for option buttons
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mt-answer]');
      if (btn) {
        var key = btn.getAttribute('data-mt-answer');
        var val = btn.getAttribute('data-mt-value');
        state[key] = val;

        // Visual selection feedback
        var siblings = btn.parentElement.querySelectorAll('[data-mt-answer]');
        siblings.forEach(function (s) { s.style.borderColor = ''; });
        btn.style.borderColor = 'var(--mt-blue)';
        btn.style.background = 'var(--mt-bg-soft)';

        // Auto-advance
        setTimeout(function () {
          if (key === 'customer_type') {
            showStep(2);
          } else if (key === 'track_type') {
            showStep(3);
          }
        }, 250);
        return;
      }

      // Back button
      var backBtn = e.target.closest('[data-mt-back]');
      if (backBtn) {
        e.preventDefault();
        if (state.currentStep > 1) showStep(state.currentStep - 1);
        return;
      }
    });

    // Form submit handler
    var form = root.querySelector('[data-mt-config-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        state.brief = (fd.get('brief') || '').toString().trim();
        state.name = (fd.get('name') || '').toString().trim();
        state.phone = (fd.get('phone') || '').toString().trim();

        if (!state.name || !state.phone) {
          form.reportValidity();
          return;
        }

        // Build the WhatsApp message
        var message = buildMessage(state);
        var url = whatsappBase + '?text=' + encodeURIComponent(message);

        // Fire completion event with custom tags
        fireClarity('configurator_complete', {
          user_type: state.customer_type,
          track_type: state.track_type,
          intent: 'quote'
        });

        // Show thanks screen + open WhatsApp in new tab
        showStep('thanks');
        var thanksLink = root.querySelector('[data-mt-thanks-link]');
        if (thanksLink) thanksLink.setAttribute('href', url);

        var newWin = window.open(url, '_blank');
        // Fallback if popup blocked
        if (!newWin) {
          if (thanksLink) thanksLink.click();
        }
      });
    }

    // Build the auto-message
    function buildMessage(s) {
      var lines = [
        "Hi Jainsons! I'm interested in a magnetic track system.",
        "",
        "About me: " + (s.customer_type || 'Not specified'),
        "Track type I want: " + (s.track_type || 'Not specified'),
        ""
      ];
      if (s.brief) {
        lines.push("My project:");
        lines.push(s.brief);
        lines.push("");
      }
      lines.push("Please share catalogue and help me with the right system.");
      return lines.join("\n");
    }

    // Fire 'configurator_open' once when first interaction begins
    var openFired = false;
    root.addEventListener('mousedown', function () {
      if (!openFired) {
        fireClarity('configurator_open');
        openFired = true;
      }
    }, { once: true });
    root.addEventListener('touchstart', function () {
      if (!openFired) {
        fireClarity('configurator_open');
        openFired = true;
      }
    }, { once: true, passive: true });
  }
})();
